export function getErrorMessageByLang(lang: string) {
    let errorMessage = '';

    if (lang === 'ru') {
        errorMessage = 'Произошла ошибка при загрузке элементов. Попробуйте через пару минут';
    } else if (lang === 'en') {
        errorMessage = 'An error occurred while loading elements. Please try again in a few minutes';
    } else {
        errorMessage = 'An error occurred while loading elements. Please try again in a few minutes';
    }

    return errorMessage;
}
